var configMiddleware = function (config) { return function (dispatch) { return function (next, done) { return function (message) {
    if (message.domain !== 'config') {
        return next(message);
    }
    if (message.eventType !== 'get') {
        throw "Invalid event type " + message.eventType + " for domain config";
    }
    var result = message.data.data.keys.reduce(function (acc, key) {
        var data = config[key] ? config[key] : null;
        acc[key] = { value: data };
        return acc;
    }, {});
    dispatch({
        purpose: 'response',
        request_id: message.data.request_id,
        response_data: result,
    });
    done();
}; }; }; };
export default configMiddleware;
//# sourceMappingURL=config.js.map